var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13635_493363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28109 3.57617C8.1105 3.57617 7.93973 3.64245 7.80973 3.77279L7.75244 3.83008C7.49177 4.09074 7.49177 4.51279 7.75244 4.77279L10.328 7.34831H1.61442C1.24642 7.34831 0.947754 7.64697 0.947754 8.01497C0.947754 8.38297 1.24642 8.68164 1.61442 8.68164H10.328L7.75244 11.2572C7.49177 11.5178 7.49177 11.9399 7.75244 12.1999L7.80973 12.2572C8.0704 12.5178 8.49244 12.5178 8.75244 12.2572L12.5233 8.48633C12.7839 8.22566 12.7839 7.80362 12.5233 7.54362L8.75244 3.77279C8.62211 3.64245 8.45167 3.57617 8.28109 3.57617Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7188,
    y: 3,
    width: 1.33333,
    height: 10,
    rx: 0.666667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13635_493363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/ArrowNext.303af38618f35173de79faccb52a80a8.svg";
export { ForwardRef as ReactComponent };